export const EMPLOYEE_DOCUMENT_TYPES = [
  'Kimlik ve SGK Evrakları',
  'İSG Eğitim Belgeleri',
  'KKD Teslim Tutanakları',
  'Mesleki Yeterlilik Belgeleri',
  'Operatör Belgeleri',
  'Sağlık Raporları',
  'Acil Durum ve Tahliye Eğitimleri',
  'Çalışma İzin Belgeleri',
  'Taşeron Sözleşme Evrakları',
  'Disiplin ve Uyarı Tutanakları',
  'Diğer',
];
